import axios from '../axios';

// @context TGW-2591 「一言から作る」「写真から読み取る」でタイトルを反映しても、画面の状態が
//   変わるだけでDBには保存されていなかった（main.js の updateTitleContent が定義ごと
//   コメントアウトされ、呼び出し側は `?.` で黙って何もしない状態だった）。
//   紹介文は20秒ごとに自動保存されるのに対しタイトルには自動保存が無いため、
//   リロードすると「古いタイトル＋新しい紹介文」というちぐはぐな状態になっていた。
//
//   保存先は入口の「次へ」（entry_logic.js）と同じ /api/event_edit/update_title に揃える。
//   公開済みイベントでもタイトルに紐づく派生データ（検索インデックス・OGP・カバー画像）を
//   サーバ側で更新するので、下書きかどうかで出し分けない。

export const saveTitle = (eventId, title) =>
  axios.post(
    '/api/event_edit/update_title',
    JSON.stringify({ event_id: eventId, title: (title || '').trim() })
  );

// @context TGW-2591 カバー画像はタイトルを焼き込んだ画像なので、タイトルを変えると作り直される。
//   作り直しは Sidekiq で非同期に走るため、保存した直後はまだ古い画像が返る。
//   リロードすれば新しくなるが、利用者はリロードしないので、できあがるまで様子を見て差し替える。
//   タイトルを変えると、まずタグ無しの画像が数秒で用意され、カテゴリの付け直しが
//   追いついたところでタグ付きに作り直される。2回変わるので、1回目で打ち切らず最後まで見る。
export const COVER_POLL_INTERVAL_MS = 1500;
export const COVER_POLL_MAX_ATTEMPTS = 14;

// カバー画像が既にあるときは作らずに現在のURLを返すので、取得用として使える
export const fetchCoverImageUrl = (eventId, title) =>
  axios
    .post(
      '/api/event/generate_default_image',
      JSON.stringify({ event_id: eventId, event_title: title })
    )
    .then((res) => res.data.main_image_url);

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// 新しいURLになるたびに onUpdated を呼ぶ。タグ無し→タグ付きの2段階があるので最後まで見る。
// 間に合わなくても編集は続けられる（画面は古いまま、リロードで新しくなる）
export const watchCoverImage = async (
  eventId,
  title,
  previousUrl,
  onUpdated,
  {
    attempts = COVER_POLL_MAX_ATTEMPTS,
    intervalMs = COVER_POLL_INTERVAL_MS,
    sleep = wait,
    fetchUrl = fetchCoverImageUrl,
  } = {}
) => {
  let lastUrl = previousUrl;

  for (let i = 0; i < attempts; i += 1) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const url = await fetchUrl(eventId, title);
      if (url && url !== lastUrl) {
        lastUrl = url;
        onUpdated(url);
      }
    } catch (error) {
      // 取得に失敗しても編集は続けられる。次の回で取り直す
    }
    // eslint-disable-next-line no-await-in-loop
    await sleep(intervalMs);
  }

  return lastUrl === previousUrl ? null : lastUrl;
};
